/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { logo } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import "./Navbar.css";
import Template from "../Template/Template.tsx";

const Navbar = () => {
  const [isSidebarVisible, setSidebarVisibility] = useState(false);
  const [isNavbarVisible, setNavbarVisibility] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setNavbarVisibility(false);
      } else {
        setNavbarVisibility(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const openMenu = () => {
    setSidebarVisibility(!isSidebarVisible);
  };

  const history = useHistory();

  useGSAP(() => {
    gsap.from(".gsaplogo", {
      y: -30,
      opacity: 0,
      duration: 1,
      delay: 1,
    });
  });

  useGSAP(() => {
    gsap.from(".gsapRightSideNav", {
      y: -30,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      delay: 1,
    });
  });

  
  const handleContact = () => {
    window.location.href = "tel:9822081419";
  };

  const handleEmail = () => {
    window.location.href = "mailto:info@kamdhenudevelopers.com";
  };
  const handleHomeclick = () => {
    setSidebarVisibility(false);
    history.push("/");
  };
  const handlemenuclick = () => {
    setSidebarVisibility(false);
    history.push("/");
  };

  const handleAboutUsclick = () => {
    setSidebarVisibility(false);
    history.push("/About-us");
  };
  const [openSection, setOpenSection] = useState(null);

  const handleSectionClick = (sectionName) => {
    setOpenSection((prevOpenSection) =>
      prevOpenSection === sectionName ? null : sectionName
    );
  };
  const HandleWhatsApp = () => {
    const phoneNumber = "+919822081419";
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };
  return (
    <div>
      {/* <Template/> */}
    <div
      className="NavbarContainer"
      style={{
        ...webStyle.container,
        position:"fixed",
        top: "0",
       height:isNavbarVisible ? "92px" : "auto",
      //  paddingTop:isNavbarVisible ? "30px" : "0px"
      }}
    >
      <div style={{ display: "flex",alignItems:"center" }} className="navbarLogoContainer">
        <img
          onClick={() => history.push("/")}
          src={logo}
          style={{ ...webStyle.logo,
       height:isNavbarVisible ? "80px" : "60px",
      margin:isNavbarVisible ? "0px" : "10px"

           }}
          className="logo gsaplogo"
        />
        <div>
        </div>
      </div>
      <Box
        style={{ ...webStyle.optionsDiv, padding: "0 40px" }}
        className="item"
      >
        <div className="dropdown gsapRightSideNav">
          <a onClick={() => history.push("/")} style={{ textDecoration: "none" }}>
            <span
              className="items RouteOptions"
              style={{...webStyle.HeadingOption,
                fontSize:isNavbarVisible ? "20px" : "15px",
              }}
            >
              Home
            </span>
          </a>
        </div>
        {/* <div className="dropdown gsapRightSideNav">
          <a href="#TableView" onClick={() => history.push("/")} style={{ textDecoration: "none" }}>
            <span
              className="items RouteOptions"
              style={{...webStyle.HeadingOption,
                fontSize:isNavbarVisible ? "20px" : "15px",
              }}
            >
              Table View
            </span>
          </a>
        </div> */}

        <div className="dropdown gsapRightSideNav">
          <a  onClick={() => history.push("/")}   href="#about-us" className="items RouteOptions" style={{...webStyle.HeadingOption,
                fontSize:isNavbarVisible ? "20px" : "15px",
              }}>
            About Us
          </a>
        </div>
        <div className="dropdown gsapRightSideNav">
          <a  onClick={() => history.push("/")}   href="#ourProjects" className="items RouteOptions" style={{...webStyle.HeadingOption,
                fontSize:isNavbarVisible ? "20px" : "15px",
              }}>
            Projects
          </a>
        </div>
        <div className="dropdown gsapRightSideNav">
          <a  onClick={() => history.push("/")} href="#Gallery" className="items RouteOptions" style={{...webStyle.HeadingOption,
                fontSize:isNavbarVisible ? "20px" : "15px",
              }}>
          Gallery 
          </a>
        </div>
        <div className="dropdown-container">
  <div className="dropdown gsapRightSideNav">
    <span
      className="items RouteOptions profile"
      style={{
        ...webStyle.HeadingOption,
        fontSize: isNavbarVisible ? "20px" : "15px",
      }}
    >
      Contact Us
    </span>
  </div>
  <div className="menu">
    <ul>
      <li><a onClick={handleContact}><i className="ph-bold ph-user"></i>Call Us</a></li>
      <li><a onClick={HandleWhatsApp}><i className="ph-bold ph-gear-six"></i>Whatsapp Us</a></li>
      <li><a onClick={handleEmail}><i className="ph-bold ph-gear-six"></i>Email Us</a></li>
    </ul>
  </div>
</div>

      </Box>
      <Box className="item gsapRightSideNav  humburger-menu">
        <MenuIcon
          onClick={openMenu}
          style={{ fontSize: "35px", marginRight: "20px", color: "white" }}
        />
      </Box>
      {/* ====================  Hamburger is starting from here ===================================*/}
      {isSidebarVisible && (
        <Box className="sidebar">
          <div
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "space-between",
              width: "98%",
              margin: "12px",
            }}
          >
            <img
              onClick={() => history.push("/")}
              src={logo}
              style={webStyle.logo}
              className="logo"
            />
            <CloseIcon
              onClick={() => setSidebarVisibility(false)}
              style={{ marginRight: "15px", color: "white", fontSize: "25px" }}
            />
          </div>

          <Box style={{ width: "100%" }} className="scrollable-section">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                lineHeight: "2.5",
                width: "100%",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <a
                      onClick={handleHomeclick}
                      style={{
                        ...webStyle.HeadingOption,
                        borderBottom: "1px solid grey",
                        padding: "15px",
                        margin: "0",
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      <span>Home</span>
                    </a>
                    <a
                    href="#Menu" 
                      onClick={handlemenuclick}
                      style={{
                        ...webStyle.HeadingOption,
                        borderBottom: "1px solid grey",
                        padding: "15px",
                        margin: "0",
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      <span>Menu</span>
                    </a>
                    <a
                    href="#about-us"
                      onClick={handleHomeclick}
                      style={{
                        ...webStyle.HeadingOption,
                        borderBottom: "1px solid grey",
                        padding: "15px",
                        margin: "0",
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      <span>About us</span>
                    </a>
                    <a
                    href="#Gallery"
                      onClick={handleHomeclick}
                      style={{
                        ...webStyle.HeadingOption,
                        borderBottom: "1px solid grey",
                        padding: "15px",
                        margin: "0",
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      <span>Gallery</span>
                    </a>
                  </div>
                    <p
                    onClick={() => handleSectionClick("Contact Us")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // background: "white",
                      justifyContent: "space-between",
                      padding: "15px",
                      border: "none",
                      borderBottom: "1px solid grey",
                      margin: "0",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          margin: "0px",
                          cursor: "pointer",
                          color: "white",
                          fontSize: "20px",
                        }}
                      >
                        Contact Us
                      </span>
                    </div>
                    <span>
                      {openSection === "Contact Us" ? (
                        <KeyboardArrowUpIcon
                          style={{ fontSize: "15px", color: "white" }}
                        />
                      ) : (
                        <KeyboardArrowDownIcon
                          style={{ fontSize: "15px", color: "white" }}
                        />
                      )}
                    </span>
                  </p>
                  {openSection === "Contact Us" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        className="options"
                        style={{ ...webStyle.options, color: "white" }}
                        onClick={() => {
                          handleContact();
                          setSidebarVisibility(false);
                        }}
                      >
                        Call us
                      </span>
                      <span
                        className=" options"
                        style={{ ...webStyle.options, color: "white" }}
                        onClick={() => {
                          HandleWhatsApp();
                          setSidebarVisibility(false);
                        }}
                      >
                        Whatsapp us
                      </span>
                      <span
                        className=" options"
                        style={{ ...webStyle.options, color: "white" }}
                        onClick={() => {
                          handleEmail();
                          setSidebarVisibility(false);
                        }}
                      >
                        Email us
                      </span>
                    </div>
                  )}{" "}
                  
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </div>
    </div>
  );
};

const webStyle = {
  container: {
    backgroundColor: "#597a4b",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    // padding: "10px 0 0 0",
    // height: "auto",
    width: "100%",
    zIndex: "1111",
    transition: "top 0.3s",
  },
  MenuButtonStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    border: "none",
    color: "black",
  },
  logo: {
    height: "80px",
    cursor: "pointer",
    borderRadius: "8px",
  },
  options: {
    padding: "15px",
    fontWeight: 600,
    borderBottom: "1px solid grey",
    cursor: "pointer",
  },
  optionsDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  HeadingOption: {
    marginRight: "40px",
    cursor: "pointer",
    color: "white",
    fontSize: "20px",
  },
  dropdown: {
    position: "absolute",
    backgroundColor: "white",
    border: "1px solid #ccc",
    width: "100%",
    maxHeight: "200px",
    overflowY: "auto",
    zIndex: 1000,
  },
  dropdownItem: {
    padding: "10px",
    cursor: "pointer",
    display: "flex",
    textTransform: "capitalize",
    alignItems: "center",
    fontSize: "14px",
  },
  itemImage: {
    width: "40px",
    height: "40px",
    marginRight: "10px",
  },
};

export default Navbar;
